<div class="auth-container">
  <!-- Left Panel: Promotional Section -->
  <div class="auth-left-panel">
    <div class="left-panel-content">
      <a routerLink="/" class="back-link">
        <i class="fas fa-arrow-left"></i>
        <span>Back to Website</span>
      </a>
      
      <div class="promotional-content">
        <img src="/logo.svg" alt="Strong Towing Services" class="promo-logo" />
        <h1 class="promo-heading">Reliable Service. Fast Response. Trusted Partners.</h1>
        <p class="promo-description">
          From emergency roadside assistance to professional towing services, we're here to help you get back on the road quickly and safely.
        </p>
      </div>
    </div>
    <div class="geometric-background"></div>
  </div>

  <!-- Right Panel: Login Form -->
  <div class="auth-right-panel">
    <div class="auth-card">
      <div class="auth-header">
        <h2>Welcome Back!</h2>
        <p>Log in to access your account and manage your services.</p>
      </div>

      <form class="auth-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input
            type="email"
            id="email"
            class="form-control"
            formControlName="email"
            placeholder="Input your email"
            [class.is-invalid]="isFieldInvalid('email')"
          />
          @if (isFieldInvalid('email')) {
            <div class="invalid-feedback">
              @if (loginForm.get('email')?.errors?.['required']) {
                <span>Email is required</span>
              }
              @if (loginForm.get('email')?.errors?.['email']) {
                <span>Please enter a valid email</span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <div class="password-input">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              class="form-control"
              formControlName="password"
              placeholder="Input your password"
              [class.is-invalid]="isFieldInvalid('password')"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
            >
              <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
            </button>
          </div>
          @if (isFieldInvalid('password')) {
            <div class="invalid-feedback">
              @if (loginForm.get('password')?.errors?.['required']) {
                <span>Password is required</span>
              }
              @if (loginForm.get('password')?.errors?.['minlength']) {
                <span>Password must be at least 6 characters</span>
              }
            </div>
          }
        </div>

        <div class="form-options">
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="rememberMe"
              class="checkbox-input"
            />
            <span class="checkbox-text">Remember Me</span>
          </label>
          <a routerLink="/forgot-password" class="forgot-password">Forgot Password?</a>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-block"
          [disabled]="loginForm.invalid || isLoading"
        >
          @if (!isLoading) {
            <span>Login</span>
          }
          @if (isLoading) {
            <span class="spinner"></span>
          }
        </button>

        @if (errorMessage) {
          <div class="alert alert-danger">
            {{ errorMessage }}
          </div>
        }
      </form>

      <div class="auth-footer">
        <p>Don't have an account? <a routerLink="/register">Sign up here</a></p>
      </div>
    </div>
  </div>
</div>